import { defineStore } from "pinia";

export const useStorageStore = defineStore("storage", {
  actions: {
    setEditData(key, value) {
      localStorage.setItem(key, JSON.stringify(value));
    },

    getEditData(key) {
      const value = localStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    },

    removeEditData(key) {
      localStorage.removeItem(key);
    },

    clearLocalStorage() {
      localStorage.clear();
    },
  },
});